import { FC } from 'react';
import { ConversationMissedEvent } from '@vs-online-only-app/state';
import ConversationOutcomeCard, {
  ConversationOutcomeCardType,
} from './ConversationOutcomeCard';

type Props = {
  event: ConversationMissedEvent;
  onClose: () => void;
};

const NewConversationMissedCard: FC<Props> = ({ event, onClose }) => {
  const {
    data: { new: isNewShopper, subType, numberOfAssociatesInPool },
    conversation: {
      conversationStarter: { firstName: shopperFirstName },
    },
  } = event;

  return (
    <ConversationOutcomeCard
      type={
        isNewShopper
          ? ConversationOutcomeCardType.CONVERSATION_REQUEST_NEW_SHOPPER
          : ConversationOutcomeCardType.CONVERSATION_REQUEST_FAMILIAR_SHOPPER
      }
      title={`You've missed a chat from ${shopperFirstName}.`}
      subtitle={
        subType === 'associate-missed' && numberOfAssociatesInPool
          ? 'The customer is now being redirected to other team members.'
          : `This customer didn't get a response.`
      }
      onClose={onClose}
    />
  );
};

export default NewConversationMissedCard;
